import React, { useSyncExternalStore } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { House, SquaresFour, Heart, MapPin, User } from '@phosphor-icons/react';
import telegramService from '../services/telegram';
import { subscribeModalStack, getModalCount } from '../utils/modalStack';
import './BottomNavigation.css';

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = telegramService.getUser();

  // Меню прячется под открытой панелью. Оно лежит выше модалки (z-index 1000
  // против z-modal 60), поэтому иначе перекрывает её нижние строки. Заодно
  // снимает противоречие: фон под затемнением недоступен, а навигация по нему
  // оставалась нажимаемой
  const modalCount = useSyncExternalStore(subscribeModalStack, getModalCount);
  const hidden = modalCount > 0;

  const handleNavigation = (path) => {
    if (window.Telegram?.WebApp?.HapticFeedback) {
      window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
    }
    navigate(path);
  };

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    // Для кнопки категорий проверяем точное совпадение с /category или начинается с /category/
    if (path === '/category') {
      return location.pathname === '/category' || location.pathname.startsWith('/category/');
    }
    return location.pathname.startsWith(path);
  };

  // Активный пункт отличается весом иконки, а не отдельным набором —
  // брендбук 9.2: fill означает «включено»
  const navItems = [
    { path: '/', label: 'Главная', Icon: House },
    { path: '/category', label: 'Категории', Icon: SquaresFour },
    { path: '/favorites', label: 'Избранное', Icon: Heart },
    { path: '/nearby', label: 'Рядом', Icon: MapPin },
    { path: '/profile', label: 'Профиль', Icon: User, isProfile: true },
  ];

  return (
    <nav
      className={`bottom-navigation${hidden ? ' bottom-navigation--hidden' : ''}`}
      // Скрытое меню не должно ловить фокус табом из открытой панели.
      // inert в React 19 — обычный булев проп
      aria-hidden={hidden}
      inert={hidden}
    >
      {navItems.map((item) => {
        const active = isActive(item.path);
        const { Icon } = item;
        const weight = active ? 'fill' : 'regular';

        return (
          <button
            key={item.path}
            onClick={() => handleNavigation(item.path)}
            className={`bottom-nav-item ${active ? 'active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            {item.isProfile ? (
              <div className="nav-icon profile-icon">
                {user?.photo_url ? (
                  <img src={user.photo_url} alt="Profile" />
                ) : (
                  <Icon size={24} weight={weight} />
                )}
              </div>
            ) : (
              <div className="nav-icon">
                <Icon size={24} weight={weight} />
              </div>
            )}
            <span className="nav-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNavigation;
